
import { defineComponent } from 'vue';
import config from '@/shared/constants/config';
import ResizableImage from '@/shared/components/ResizableImage.vue';
import { adService } from './AdService';

export default defineComponent({
  components: {
    ResizableImage,
  },
  props: {
    adFrontId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ad: null as any,
      url: null as string | null,
      isLoading: true,
      logoUrl: config.BASE_URL + '/img/logo.svg',
    };
  },
  async created() {
    this.isLoading = true;
    try {
      const result = await adService.getById(this.adFrontId);
      this.ad = result.data.model;
      const routeData = this.$router.resolve({ name: 'AdDetail', params: { adFrontId: this.adFrontId } });
      this.url = config.BASE_URL + routeData.href;
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    async share() {
      try {
        await adService.share(this.ad.adId);
      } catch (error) {
        console.error(error);
      }
    },
    scrollToShare() {
      const el = this.$el.parentNode.getElementsByClassName('page-content__header')[0];

      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
  },
});
